import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { INotification, INotificationListResponse } from 'src/app/models/dashboard.models';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  notifications: Array<INotification> = [];
  LIMIT: number = 20;
  loading: boolean;
  fetchedAll: boolean = false;

  constructor(public dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.fetchedAll = false;
    this.getNotifications();
  }

  getNotifications(){
    if(!this.fetchedAll){
      let body = {
        limit: this.LIMIT,
        offset: this.notifications.length
      }
      this.loading = true;
      
      this.dashboardService.getNotificationsMidwife(body)
      .subscribe((res: INotificationListResponse)=>{
        this.fetchedAll = res.payload.length < this.LIMIT ? true : false;
        res.payload.forEach(notify => {
          let temp = new Date(notify.date);
          temp.setHours(temp.getHours() - 7);
          temp.setMinutes(temp.getMinutes() - 30);
          notify.date = temp;
        });
        this.loading = false;
        this.notifications = this.notifications.concat(res.payload);
        console.log("Notifications Midwife:", res.payload);
      },err=>{
        console.error("Notifications Midwife Error", err);
        this.loading = false;
      });
    }
  }

}
